import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

const AnalysisTitle = ({ incrementalId, gitCommitMessage, variant, projectId }) => {
    return (
        <Box display="flex" alignItems="center" overflow="hidden">
            {incrementalId && projectId && (
                <Typography
                    variant={variant}
                    color="textSecondary"
                    sx={{ marginRight: '8px' }}
                >
                    #{incrementalId}
                </Typography>
            )}
            <Typography
                variant={variant}
                component="p"
                sx={{
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                }}
            >
                {gitCommitMessage}
            </Typography>
        </Box>
    );
};

AnalysisTitle.propTypes = {
    incrementalId: PropTypes.number,
    gitCommitMessage: PropTypes.string,
    variant: PropTypes.string,
    projectId: PropTypes.string,
};

AnalysisTitle.defaultProps = {
    variant: 'h5',
};

export default AnalysisTitle;
